import { createSignal, onCleanup, onMount } from 'solid-js'

export function useMediaQuery(query: string) {
  const [matches, setMatches] = createSignal(
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false
  )

  onMount(() => {
    const mediaQuery = window.matchMedia(query)
    setMatches(mediaQuery.matches)

    const handler = (e: MediaQueryListEvent) => {
      setMatches(e.matches)
    }

    mediaQuery.addEventListener('change', handler)

    onCleanup(() => {
      mediaQuery.removeEventListener('change', handler)
    })
  })

  return matches
}

export const useIsMobile = () => useMediaQuery('(max-width: 768px)')
export const useIsTablet = () => useMediaQuery('(max-width: 1024px)')
export const usePrefersDark = () => useMediaQuery('(prefers-color-scheme: dark)')
